module.exports = __webpack_public_path__ + "img/744.4ae9157f.jpg";